export const BIDIB_LINK_DESCRIPTOR_ROLE_INTERFACE = 1
export const BIDIB_LINK_DESCRIPTOR_ROLE_NODE = 2
export const BIDIB_LINK_DESCRIPTOR_ROLE_BOTH = 3

export const MSG_BOOST_OFF = 0x30
export const MSG_BOOST_ON = 0x31


const MSG_DSTRM = 0x00
const MSG_DFC = (MSG_DSTRM + 0x10)
export const MSG_FEATURE_SET = (MSG_DFC + 0x03)



//===============================================================================
//
// 4. Feature Codes
//
//===============================================================================

export const feature = {
    //-- occupancy
    'FEATURE_BM_SIZE': {code: 0, desc: 'number of occupancy detectors'},
    'FEATURE_BM_ON': {code: 1, desc: 'occupancy detection on/off'},
    'FEATURE_BM_SECACK_AVAILABLE': {code: 2, desc: 'secure ack available'},
    'FEATURE_BM_SECACK_ON': {code: 3, desc: 'secure ack on/off'},
    'FEATURE_BM_CURMEAS_AVAILABLE': {code: 4, desc: 'occupancy detectors with current measurement results'},
    'FEATURE_BM_CURMEAS_INTERVAL': {code: 5, desc: 'interval for current measurements'},
    'FEATURE_BM_DC_MEAS_AVAILABLE': {code: 6, desc: '(dc) measurements available, even if track voltage is off'},
    'FEATURE_BM_DC_MEAS_ON': {code: 7, desc: 'dc measurement enabled'},
//-- bidi detection
    'FEATURE_BM_ADDR_DETECT_AVAILABLE': {code: 8, desc: 'detector ic capable to detect loco address'},
    'FEATURE_BM_ADDR_DETECT_ON': {code: 9, desc: 'address detection enabled'},
    'FEATURE_BM_ADDR_AND_DIR': {code: 10, desc: 'addresses contain direction'},
    'FEATURE_BM_ISTSPEED_AVAILABLE': {code: 11, desc: 'speed messages available'},
    'FEATURE_BM_ISTSPEED_INTERVAL': {code: 12, desc: 'speed update interval'},
    'FEATURE_BM_CV_AVAILABLE': {code: 13, desc: 'CV readback available'},
    'FEATURE_BM_CV_ON': {code: 14, desc: 'CV readback enabled'},
//-- booster
    'FEATURE_BST_VOLT_ADJUSTABLE': {code: 15, desc: 'booster output voltage is adjustable'},
    'FEATURE_BST_VOLT': {code: 16, desc: 'booster output voltage setting (unit: V)'},
    'FEATURE_BST_CUTOUT_AVAILABLE': {code: 17, desc: 'booster can do cutout for railcom'},
    'FEATURE_BST_CUTOUT_ON': {code: 18, desc: 'cutout is enabled'},
    'FEATURE_BST_TURNOFF_TIME': {code: 19, desc: 'time in ms until booster turns off in case of a short (unit 2ms)'},
    'FEATURE_BST_INRUSH_TURNOFF_TIME': {
        code: 20,
        desc: 'time in ms until booster turns off in case of a short after the first power up (unit 2ms)'
    },
    'FEATURE_BST_AMPERE_ADJUSTABLE': {code: 21, desc: 'booster output current is adjustable'},
    'FEATURE_BST_AMPERE': {code: 22, desc: 'booster output current value (special coding)'},
    'FEATURE_BST_CURMEAS_INTERVAL': {code: 23, desc: 'current update interval'},
    'FEATURE_BST_CV_AVAILABLE': {code: 24, desc: '(deprecated, now synonym to 13) CV readback available'},
    'FEATURE_BST_CV_ON': {code: 25, desc: '(deprecated, now synonym to 14) CV readback enabled'},
    'FEATURE_BST_INHIBIT_AUTOSTART': {
        code: 26,
        desc: '1: Booster does no automatic BOOST_ON when DCC at input wakes up.'
    },
    'FEATURE_BST_INHIBIT_LOCAL_ONOFF': {
        code: 27,
        desc: '1: Booster announces local STOP/GO key stroke only, no local action'
    },

//-- bidi detection
    'FEATURE_BM_DYN_STATE_INTERVAL': {code: 28, desc: 'transmit interval of MSG_BM_DYN_STATE (unit 100ms)'},
    'FEATURE_BM_RCPLUS_AVAILABLE': {code: 29, desc: '1: RailcomPlus messages available (deprecated)'},
    'FEATURE_BM_EXT_AVAILABLE': {code: 29, desc: 'Bit 0: RCPLUS available; Bit 2: DCCA available.'},
//-- occupancy
    'FEATURE_BM_TIMESTAMP_ON': {code: 30, desc: '1: OCC will be sent with timestamp'},
//-- bidi detection
    'FEATURE_BM_POSITION_ON': {code: 31, desc: 'position messages enabled'},
    'FEATURE_BM_POSITION_SECACK': {code: 32, desc: 'secure position ack interval (unit: 10ms), 0: none'},

//-- accessory
    'FEATURE_ACCESSORY_COUNT': {code: 40, desc: 'number of objects'},
    'FEATURE_ACCESSORY_SURVEILLED': {code: 41, desc: '1: announce if operated outside bidib'},
    'FEATURE_ACCESSORY_MACROMAPPED': {code: 42, desc: '1..n: no of accessory aspects are mapped to macros'},

//-- control
    'FEATURE_CTRL_INPUT_COUNT': {code: 50, desc: 'number of inputs for keys'},
    'FEATURE_CTRL_INPUT_NOTIFY': {code: 51, desc: '1: report a keystroke to host'},
    'FEATURE_CTRL_SWITCH_COUNT': {code: 52, desc: 'number of switch ports (direct controlled)'},
    'FEATURE_CTRL_LIGHT_COUNT': {code: 53, desc: 'number of light ports (direct controlled)'},
    'FEATURE_CTRL_SERVO_COUNT': {code: 54, desc: 'number of servo ports (direct controlled)'},
    'FEATURE_CTRL_SOUND_COUNT': {code: 55, desc: 'number of sound ports (direct controlled)'},
    'FEATURE_CTRL_MOTOR_COUNT': {code: 56, desc: 'number of motor ports (direct controlled)'},
    'FEATURE_CTRL_ANALOGOUT_COUNT': {code: 57, desc: 'number of analog ports (direct controlled)'},
    'FEATURE_CTRL_STRETCH_DIMM': {code: 58, desc: 'additional time stretch for dimming (for light ports)'},
    'FEATURE_CTRL_BACKLIGHT_COUNT': {code: 59, desc: 'number of backlight ports (intensity direct controlled)'},
    'FEATURE_CTRL_MAC_LEVEL': {code: 60, desc: 'supported macro level'},
    'FEATURE_CTRL_MAC_SAVE': {code: 61, desc: 'number of permanent storage places for macros'},
    'FEATURE_CTRL_MAC_COUNT': {code: 62, desc: 'number of macros'},
    'FEATURE_CTRL_MAC_SIZE': {code: 63, desc: 'length of each macro (entries)'},
    'FEATURE_CTRL_MAC_START_MAN': {code: 64, desc: '(local) manual control of macros enabled'},
    'FEATURE_CTRL_MAC_START_DCC': {code: 65, desc: '(local) dcc control of macros enabled'},
    'FEATURE_CTRL_PORT_QUERY_AVAILABLE': {
        code: 66,
        desc: '1: node will answer to output queries via MSG_LC_PORT_QUERY'
    },
    'FEATURE_SWITCH_CONFIG_AVAILABLE': {
        code: 67,
        desc: '(deprecated, version >= 0.6 uses availability of PCFG_IO_CTRL) 1: node has possibility to configure switch ports'
    },
    'FEATURE_CTRL_PORT_FLAT_MODEL': {code: 70, desc: 'node uses flat port model, "low" number of addressable ports'},
    'FEATURE_CTRL_PORT_FLAT_MODEL_EXTENDED': {
        code: 71,
        desc: 'node uses flat port model, "high" number of addressable ports'
    },
    /* deprecated names (as of revision 1.24), do not use */
    'FEATURE_CTRL_SPORT_COUNT': {code: 52, desc: '(deprecated)'},
    'FEATURE_CTRL_LPORT_COUNT': {code: 53, desc: '(deprecated)'},
    'FEATURE_CTRL_ANALOG_COUNT': {code: 57, desc: '(deprecated)'},
    'FEATURE_SPORT_CONFIG_AVAILABLE': {code: 67, desc: '(deprecated)'},

//-- dcc gen
    'FEATURE_GEN_SPYMODE': {code: 100, desc: '1: watch bidib handsets'},
    'FEATURE_GEN_WATCHDOG': {
        code: 101,
        desc: '0: no watchdog, 1: permanent update of MSG_CS_SET_STATE required, unit 100ms'
    },
    'FEATURE_GEN_DRIVE_ACK': {code: 102, desc: 'not used'},
    'FEATURE_GEN_SWITCH_ACK': {code: 103, desc: 'not used'},
    'FEATURE_GEN_LOK_DB_SIZE': {code: 104, desc: '#define FEATURE_GEN_LOK_DB_STRING          105  //'},
    'FEATURE_GEN_POM_REPEAT': {code: 106, desc: 'supported service modes'},
    'FEATURE_GEN_DRIVE_BUS': {code: 107, desc: '1: this node drive the dcc bus.'},
    'FEATURE_GEN_LOK_LOST_DETECT': {code: 108, desc: '1: command station annouces lost loco'},
    'FEATURE_GEN_NOTIFY_DRIVE_MANUAL': {code: 109, desc: '1: dcc gen reports manual operation'},
    'FEATURE_GEN_START_STATE': {code: 110, desc: '1: power up state, 0=off, 1=on'},
    'FEATURE_GEN_RCPLUS_AVAILABLE': {code: 111, desc: '(deprecated) 1: supports rcplus messages'},
    'FEATURE_GEN_EXT_AVAILABLE': {
        code: 111,
        desc: 'bitfield supported messages: 0 - RCPLUS, 1 - M4, 2 - DCCA, other: reserved'
    },
    'FEATURE_CELL_NUMBER': {
        code: 112,
        desc: '(logical) reference mark of generator (0=single system, 1..n: area mark)'
    },
    'FEATURE_RF_CHANNEL': {code: 113, desc: 'used rf channel, 0..83 channel assignment in 2.4 GHz band'},
    'FEATURE_GEN_EXT_ENABLED': {
        code: 114,
        desc: 'bitfield enabled messages/modes: 0 - RCPLUS, 1 - M4, 2 - DCCA, other: reserved'
    },

//-- system
    'FEATURE_STRING_NAMESPACES_AVAILABLE': {code: 250, desc: 'bitfield, bit index corresponds to namespace'},
    'FEATURE_STRING_DEBUG': {code: 251, desc: 'use namespace 1 for debug strings, 0:n.a./silent (default); 1=mode 1'},
    'FEATURE_STRING_SIZE': {code: 252, desc: 'length of user strings, 0:n.a (default); allowed 8..24'},
    'FEATURE_RELEVANT_PID_BITS': {
        code: 253,
        desc: 'how many bits of vendor32 are relevant for PID (default 16, LSB aligned)'
    },
    'FEATURE_FW_UPDATE_MODE': {code: 254, desc: '0: no fw-update, 1: intel hex (max. 10 byte / record)'},
    'FEATURE_EXTENSION': {code: 255, desc: '1: reserved for future expansion'},
}

